// Libraries
import React from 'react';

// Styled
import { StyledIcon, StyledInput, Wrapper } from 'Components/flowChart/components/InputSearch/index.style';

export interface IInputSearch {
	value: string;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	placeholder?: string;
}

const InputSearch = React.forwardRef<HTMLDivElement, IInputSearch>((props, ref) => {
	const { value, onChange, placeholder } = props;

	return (
		<Wrapper ref={ref}>
			<StyledInput placeholder={placeholder} value={value} onChange={onChange} autoFocus />
			<StyledIcon type="icon-antsomi-search" />
		</Wrapper>
	);
});

InputSearch.defaultProps = {
	placeholder: 'Search...',
};

export default InputSearch;
